import { object, string, number } from 'yup';
import { useMemo } from 'react';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { useFormatting } from 'locale';
import { adapt } from './adaptKudi';

const kudiSchema = object({
    id: number().required().integer(),
    planId: number().required().integer(),
    clientId: number().required().integer(),
    lpzPlanId: string().required(),
    lpzClientId: number().required().integer(),
    vestedBenefitsAge50: number().required(),
    vestedBenefits: number().required(),
    vestedBenefitsUponMarriage: number().required(),
    wefEarlyWithdrawal: number().required(),
    repaymentWEFEarlyWithdrawal: number().required(),
    vestedBenefitsDivorce: number().required(),
    purchaseIntoPensionFund3years: number().required(),
    retirementAssetsBVG: number().required(),
    vestedBenefitsAge50LPP: number().required(),
    vestedBenefitsUponMarriageLPP: number().required(),
    wefEarlyWithdrawalLPP: number().required(),
    repaymentWEFEarlyWithdrawalLPP: number().required(),
    vestedBenefitsDivorceLPP: number().required(),
});

export const useKudi = ({ portfolioId }: { portfolioId?: number | string }) => {
    const { getFormattedNumber } = useFormatting();

    const { data: kudiRaw, isLoading, error } = useGetCustomService({
        service: 'customInvestmentService',
        api: 'getKudi',
        payload: { portfolioId },
        enabled: !!portfolioId,
        refetchOnWindowFocus: false,
    });

    const { data, isEmpty } = useMemo(() => {
        if (!kudiRaw?.data) return { data: [], isEmpty: !isLoading && (error as any)?.response?.status === 404 };

        try {
            const validatedData = kudiSchema.validateSync(kudiRaw.data);

            return { data: adapt({ data: validatedData, getFormattedNumber }), isEmpty: false };
        } catch {
            return { data: [], isEmpty: true };
        }
    }, [kudiRaw?.data, isLoading, error, getFormattedNumber]);

    return {
        isEmpty,
        isLoading,
        error,
        data,
    };
};
